var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36 18C36 26.9845 29.4173 34.4313 20.8125 35.7813V23.2031H25.0066L25.8047 18H20.8125V14.6236C20.8125 13.1998 21.51 11.8125 23.7459 11.8125H26.0156V7.38281C26.0156 7.38281 23.9555 7.03125 21.986 7.03125C17.8748 7.03125 15.1875 9.52312 15.1875 14.0344V18H10.6172V23.2031H15.1875V35.7813C6.58266 34.4313 0 26.9845 0 18C0 8.05922 8.05922 0 18 0C27.9408 0 36 8.05922 36 18Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.0066 23.2031L25.8047 18H20.8125V14.6235C20.8125 13.2 21.5099 11.8125 23.7459 11.8125H26.0156V7.38281C26.0156 7.38281 23.9558 7.03125 21.9864 7.03125C17.8748 7.03125 15.1875 9.52313 15.1875 14.0344V18H10.6172V23.2031H15.1875V35.7813C16.104 35.925 17.0432 36 18 36C18.9568 36 19.896 35.925 20.8125 35.7813V23.2031H25.0066Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fbIcon.e8fbc067dc5f91183286f916a3e2057d.svg";
export { ForwardRef as ReactComponent };